module.exports = __webpack_public_path__ + "static/face-70c5900eefd1df4b5301dcaed8712a69.jpg";